// Convert a button's screen-space center into container-relative UV (0-1, top-left origin).
// Pass `event.currentTarget` from the click handler — relying on `document.activeElement`
// is unreliable on iOS Safari, which does not focus <button> elements on tap.
export function getButtonCenterUv(
  button: HTMLElement | null | undefined,
  container: HTMLElement | null | undefined,
): [number, number] {
  const fallback: [number, number] = [0.5, 0.5];
  if (!button || !container) return fallback;

  const buttonRect = button.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  if (containerRect.width === 0 || containerRect.height === 0) return fallback;

  const cx = buttonRect.left + buttonRect.width / 2 - containerRect.left;
  const cy = buttonRect.top + buttonRect.height / 2 - containerRect.top;
  return [cx / containerRect.width, cy / containerRect.height];
}
